import React, { useState } from "react";
import LocalFrameComponent from "./Local_vars_frame";
import '../assets/css/visualization.css';
import { executePythonCode } from "../utils/visualize_util";
import useStore from "../store";

const VisualizationComponent = ({ code }) => {
  const [data, setData] = useState([]);
  const [currStep, setCurrStep] = useState(null);
  const [currStepNo, setCurrStepNo] = useState(0);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [memeUrl, setMemeUrl] = useState("");

  const setCurrentLine = useStore((state) => state.setCurrentLine);

  const highlightLine = (line) => {
    setCurrentLine(line);
  };

  const removeHighlight = () => {
    setCurrentLine(null);
  };

  const getSteps = async () => {
    setLoading(true);
    setError("");
    setMemeUrl("");

    try {
      const response = await executePythonCode(code);
      const fetchedSteps = Array.isArray(response) ? response : JSON.parse(response || "[]");

      if (fetchedSteps.length > 0) {
        setData(fetchedSteps);
        setCurrStepNo(0);
        setCurrStep(fetchedSteps[0]);
        highlightLine(fetchedSteps[0]?.line);
      } else {
        setError("No steps returned from the API.");
        setData([]);
        setCurrStep(null);
        removeHighlight();
      }
    } catch (error) {
      setError("Failed to fetch steps for visualization.");
      console.error("Error making request:", error);
      setData([]);
      setCurrStep(null);
      removeHighlight();
    } finally {
      setLoading(false);
    }
  };

  const prev = () => {
    if (currStepNo > 0) {
      const newStepNo = currStepNo - 1;
      setCurrStepNo(newStepNo);
      setCurrStep(data[newStepNo]);
      highlightLine(data[newStepNo]?.line);
    }
  };

  const next = () => {
    if (currStepNo < data.length - 1) {
      const newStepNo = currStepNo + 1;
      setCurrStepNo(newStepNo);
      setCurrStep(data[newStepNo]);
      highlightLine(data[newStepNo]?.line);
    }
  };

  return (
    <div className="main-container">
      <div>
        <button
          onClick={getSteps}
          disabled={loading}
          className="bg-gray-800 text-white px-4 py-2 rounded-md m-1 transition hover:bg-gray-600 disabled:bg-gray-400"
        >
          Visualize
        </button>
        <button
          onClick={prev}
          disabled={currStepNo === 0 || data.length === 0}
          className="bg-gray-800 text-white px-4 py-2 rounded-md m-1 transition hover:bg-gray-600 disabled:bg-gray-400"
        >
          Prev
        </button>
        <button
          onClick={next}
          disabled={currStepNo >= data.length - 1 || data.length === 0}
          className="bg-gray-800 text-white px-4 py-2 rounded-md m-1 transition hover:bg-gray-600 disabled:bg-gray-400"
        >
          Next
        </button>

        {loading && (
          <div className="loading-container">
            <div className="loading-spinner"></div>
            {memeUrl && <img src={memeUrl} alt="Loading Meme" className="meme-image" />}
          </div>
        )}
        {error && <p style={{ color: "red" }}>{error}</p>}
      </div>

      <div>
        {currStep && (
          <>
            <p>Current Step: {currStep.line}</p>
            <LocalFrameComponent step={currStep} />
          </>
        )}
      </div>
    </div>
  );
};

export default VisualizationComponent;
